module.exports = __webpack_public_path__ + "statics/img/newtop.7a9abf5c.png";